import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/lib/auth';
import { Button } from '@/components/Button';
import { AuthShell } from './SignIn';
import { auth } from '@/lib/firebase';

export function VerifyEmail() {
  const { user, signOut, resendVerification } = useAuth();
  const nav = useNavigate();
  const [busy, setBusy] = useState(false);
  const [resent, setResent] = useState(false);

  // Poll the user's verification status — when they click the link in their
  // email, refreshing the user reveals emailVerified=true.
  useEffect(() => {
    if (!user) {
      nav('/signin', { replace: true });
      return;
    }
    if (user.emailVerified) {
      nav('/', { replace: true });
      return;
    }
    const id = setInterval(async () => {
      try {
        await auth.currentUser?.reload();
        if (auth.currentUser?.emailVerified) {
          nav('/', { replace: true });
        }
      } catch {
        // ignore — next tick will retry
      }
    }, 4000);
    return () => clearInterval(id);
  }, [user, nav]);

  return (
    <AuthShell title="Verify your email">
      <p className="text-stone-700 dark:text-stone-300 text-sm">
        We sent a verification link to <strong>{user?.email}</strong>. Click it from your inbox,
        then this page will continue automatically.
      </p>
      <p className="mt-3 text-xs text-stone-500">
        Didn't get it? Check your spam folder, or resend below.
      </p>
      <div className="mt-5 space-y-3">
        <Button
          size="md"
          variant="secondary"
          loading={busy}
          onClick={async () => {
            setBusy(true);
            try {
              await resendVerification();
              setResent(true);
            } finally {
              setBusy(false);
            }
          }}
          className="w-full"
        >
          {resent ? 'Verification email sent' : 'Resend verification email'}
        </Button>
        <Button
          variant="ghost"
          size="md"
          onClick={async () => {
            await signOut();
            nav('/signin', { replace: true });
          }}
          className="w-full"
        >
          Sign out
        </Button>
      </div>
    </AuthShell>
  );
}
